export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7940.88befd2b.jpg";